import { ref } from "vue";

const tapedTwice = ref(false);
const deviceTypes = [
    { name: 'isMobile', state: window.innerWidth <= 576 },
    { name: 'isTablet', state: window.innerWidth <= 1024 },
    { name: 'isDesktop', state: window.innerWidth > 1024 },
];

export const getDeviceTypes = () => {
    return deviceTypes;
}

export const isMobile = () => {
    return deviceTypes.filter(item => item.state === true)[0].name === 'isMobile';
}

export const isTablet = () => {
    return deviceTypes.filter(item => item.state === true)[0].name === 'isTablet';
}

export const isDesktop = () => {
    return deviceTypes.filter(item => item.state === true)[0].name === 'isDesktop';
}

// This function is used to get the screen number from the session storage
export const loadScreenNumber = (number = null) => {
    if (number) sessionStorage.setItem('screenNumber', number);
    return sessionStorage.getItem('screenNumber');
};

// This function is used to prevent the default action of the click event
export const clickActionPreventDefault = (e) => {
    e.preventDefault();
};

// This function is used to prevent the default action of the touch event
export const touchActionPreventDefault = (e) => {
    if (!tapedTwice.value) {
        tapedTwice.value = true;
        setTimeout(function () { tapedTwice.value = false; }, 300);
        return false;
    }
    e.preventDefault();
};